/**
 * Mapeia os nomes técnicos dos campos em nomes amigáveis para o usuário.
 */
const camposAmigaveis = {
  usuario_nome: 'Nome do usuário',
  usuario_documento: 'CPF do usuário',
  usuario_email: 'E-mail do usuário',
  usuario_telefone: 'Telefone do usuário',
  usuario_data_nascimento: 'Data de nascimento',
  endereco_rua: 'Rua',
  endereco_numero: 'Número',
  endereco_complemento: 'Complemento',
  endereco_bairro: 'Bairro',
  endereco_cidade: 'Cidade',
  endereco_estado: 'Estado',
  endereco_cep: 'CEP',
  credor_usuario_id: 'Credor responsável',
  faturamento_valor: 'Valor',
  faturamento_vencimento: 'Data de vencimento',
  cre_parametro_taxa: 'Tipo de taxa',
  cre_parametro_inadimplencia: 'Dias de inadimplência',
};

/**
 * Converte uma mensagem técnica da API em uma mensagem amigável.
 *
 * @param {string} erro - Exemplo: "usuario_email: Expected string, received null"
 * @returns {string} - Exemplo: "E-mail do usuário é obrigatório e está em branco."
 */
export function formatarMensagemErroTecnica(erro) {
  if (typeof erro !== 'string') return erro;

  const [campoBruto, mensagemOriginal] = erro.split(':').map(p => p.trim());
  const campo = camposAmigaveis[campoBruto] || campoBruto;

  // Regras específicas para mensagens mais claras
  if (/Expected string/i.test(mensagemOriginal) && /received null/i.test(mensagemOriginal)) {
    return `${campo} é obrigatório e está em branco.`;
  }

  if (/Expected string/i.test(mensagemOriginal) && /received undefined/i.test(mensagemOriginal)) {
    return `${campo} é obrigatório e não foi preenchido.`;
  }

  if (/Required/i.test(mensagemOriginal)) {
    return `${campo} é obrigatório.`;
  }

  if (/Expected string/i.test(mensagemOriginal)) {
    return `${campo} deve ser um texto válido.`;
  }

  if (/Expected number/i.test(mensagemOriginal)) {
    return `${campo} deve ser um número válido.`;
  }

  if (/Expected boolean/i.test(mensagemOriginal)) {
    return `${campo} deve ser verdadeiro ou falso.`;
  }

  if (/Invalid/i.test(mensagemOriginal)) {
    return `${campo} está inválido.`;
  }

  return `${campo}: ${mensagemOriginal}`;
}
